<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <div class="page_content">
      <div class="creative_detail_breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><a href="/order" style="color: rgba(19,20,28,0.6);font-weight: 500;">我的订单</a></el-breadcrumb-item>
          <el-breadcrumb-item><a style="color: rgba(19,20,28,0.9);font-weight: 700;">订单详情</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 星云3.0版本样式
      <div class="order_detail">
        <h3 class="order_title">{{orderInfo.ProjectName}}</h3>
        <h4 class="order_second_title">订单信息</h4>
        <div class="order_info">
          <div class="order_info_item">
            <span class="title">订单编号：</span>
            <span class="value">{{orderInfo.OrderNum
              }}</span>
          </div>
          <div class="order_info_item">
            <span class="title">订单状态：</span>
            <span class="value">{{statusMapDesc[orderInfo.OrderStatus]}}</span>
          </div>
          <div class="order_info_item">
            <span class="title">含税总价：</span>
            <span class="value" v-if="orderInfo.OrderStatus == 1 || orderInfo.OrderStatus == 5">{{orderInfo.OrderMoney != 0 ? (orderInfo.OrderMoney + Number.EPSILON).toFixed(2) : '-'}}</span>
            <span class="value" v-else>{{orderInfo.OrderMoney != 0 ? (orderInfo.OrderMoney + Number.EPSILON).toFixed(2) : '0.00'}}</span>
          </div>
          <div class="order_info_item">
            <span class="title">下单时间：</span>
            <span class="value">{{orderInfo.CreateTimeStr}}</span>
          </div>
          <div class="order_info_item" v-show="orderInfo.ConfirmTime != 0">
            <span class="title">确认时间：</span>
            <span class="value">{{orderInfo.ConfirmTimeStr}}</span>
          </div>
          <div class="order_info_item" v-show="orderInfo.CompleteTime != 0">
            <span class="title">完成时间：</span>
            <span class="value">{{orderInfo.CompleteTimeStr}}</span>
          </div>
        </div>
        <div class="divider"></div>
        <h4 class="order_second_title">客户需求信息</h4>
        <div class="order_info customer_info">
          <div class="order_info_item">
            <span class="title">客户姓名：</span>
            <span class="value">{{orderInfo.Name}}</span>
          </div>
          <div class="order_info_item">
            <span class="title" style="width: 80px;">客户手机号：</span>
            <span class="value">{{orderInfo.Phone}}</span>
          </div>
          <div class="order_info_item demand" style="width: 200%;">
            <span class="title">需求描述：</span>
            <span class="value">{{orderInfo.Requirement}}</span>
          </div>
          <div class="order_info_item demand" style="width: 200%;">
            <span class="title" style="min-width: 70px; text-align: right">备注：</span>
            <span class="value">{{orderInfo.Notes}}</span>
          </div>
        </div>
        <div class="divider"></div>
        <h4 class="order_second_title">所选创意信息</h4>
        <el-table
            :data="originalityInfo"
            style="width: 100%"
            class="order_table"
        >
          <el-table-column prop="SerialNumber" label="编号" width="124" align="center">
          </el-table-column>
          <el-table-column prop="CategoryDesc" label="创意类目" width="180">
          </el-table-column>
          <el-table-column prop="GoodsName" label="创意名称" width="240">
          </el-table-column>
          <el-table-column prop="Desc" label="描述">
            <template slot-scope="scope">
              <el-popover
                  width="344"
                  trigger="hover"
                  :content="scope.row.Desc"
              >
                <div slot="reference">
                  <div class="">{{scope.row.Desc}}</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="GoodsCount" label="数量" width="148" align="center">
          </el-table-column>
        </el-table>
      </div>
      -->
      <div class="my_project_detail">
        <div class="my_project_detail_title">
          <span class="my_project_detail_title_code">{{orderInfo.project_name}}</span>
        </div>
        <div class="my_project_detail_content">
          <div class="my_project_detail_content_label">
            项目进度
          </div>
          <div class="my_project_detail_content_time_line">
            <div  class="my_project_detail_content_time_line_content">
              <div class="my_project_detail_content_time_line_scale" :style="{width:`${scale}%`}"></div>
              <div class="my_project_detail_content_time_line_content_item" :key="key"  v-for="(item, key) in timeLine"  :style="{left:`${item.value -1}%`}"
                   :class="scale >= item.value ? 'my_project_detail_content_time_line_content_item_active'  :''"
              >
                <img :src="scale >= item.value ? item.activeIcon : item.icon"/>
                <span class="my_project_detail_content_time_line_content_label" >{{item.label}}</span>
                <span v-if="!!item.desc" class="my_project_detail_content_time_line_content_desc" >{{item.desc}}</span>
              </div>
            </div>
          </div>
          <div class="my_project_detail_content_divider_line">
          </div>
          <div class="my_project_detail_content_label" v-if="!isEmpty(companyInfo)">
            报名信息
          </div>
          <div class="my_project_detail_content_sign_info" style="margin-bottom: 10px" :key="key" v-for="(item, key) in companyInfo">
            <div class="my_project_detail_content_sign_info_item">
              <span class="my_project_detail_content_sign_info_item_label">服务商名称：</span>
              <span class="my_project_detail_content_sign_info_item_date">{{ item }}</span>
            </div>
            <div class="my_project_detail_content_sign_info_item">
              <span class="my_project_detail_content_sign_info_item_label">关联案例/附件：</span>
              <span class="my_project_detail_content_sign_info_item_date">
                <el-button type="text" @click="showServiceInfo(key)">查看案例</el-button>
              </span>
            </div>
          </div>
          <div class="my_project_detail_content_divider_line" v-if="!isEmpty(companyInfo)">
          </div>
          <div class="my_project_detail_content_label">
            客户需求信息
          </div>
          <div class="my_project_detail_content_info">
            <div class="my_project_detail_content_info_user">
              <div class="my_project_detail_content_info_user_item">
                <span class="my_project_detail_content_info_user_item_label">客户姓名：</span>
                <span class="my_project_detail_content_info_user_item_value">{{ orderInfo.name }}</span>
              </div>
              <div class="my_project_detail_content_info_user_item">
                <span class="my_project_detail_content_info_user_item_label">客户手机：</span>
                <span class="my_project_detail_content_info_user_item_value">{{ orderInfo.phone }}</span>
              </div>
              <div class="my_project_detail_content_info_user_item">
                <span class="my_project_detail_content_info_user_item_label">含税总价：</span>
                <span class="my_project_detail_content_info_user_item_value">{{ orderInfo.order_money > 0 ? orderInfo.order_money : '' }}</span>
              </div>
            </div>
            <div class="my_project_detail_content_item">
              <div class="my_project_detail_content_item_label">需求描述：</div>
              <div class="my_project_detail_content_item_value">
                <div style="word-break: break-all;" v-html="formatRequirement">
                </div>
              </div>
            </div>
            <div class="my_project_detail_content_item">
              <div class="my_project_detail_content_item_label">附件说明：</div>
              <div class="my_project_detail_content_item_value">
                <a class="my_project_detail_content_item_value_file" target="_blank" :href="item.url" :key="key" v-for="(item, key) in annexData">{{item.filename}}</a>
              </div>
            </div>
            <div class="my_project_detail_content_item">
              <div class="my_project_detail_content_item_label">备注：</div>
              <div class="my_project_detail_content_item_value"  style="word-break: break-all;">
                {{orderInfo.notes}}
              </div>
            </div>
          </div>
          <div class="my_project_detail_content_divider_line">
          </div>
          <div class="my_project_detail_content_label">
            所选SKU
          </div>
          <el-table
              :data="originalityInfo"
              style="width: 100%"
              class="order_table"
          >
            <el-table-column prop="id" label="编号" width="124" align="center">
              <template slot-scope="scope">
                {{scope.$index + 1}}
              </template>
            </el-table-column>
            <el-table-column prop="category_desc" label="创意类目" width="180">
            </el-table-column>
            <el-table-column prop="goods_name" label="创意名称" width="240">
            </el-table-column>
            <el-table-column prop="desc" label="描述">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.desc" placement="top">
                  <div>{{scope.row.desc}}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="goods_count" label="数量" width="148" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <el-dialog custom-class="my_project_demand_modal" title="关联附件/案例" :visible.sync="serviceInfoVisible" width="680px" :before-close="handleClose2" :close-on-click-modal="false">
        <div class="my_project_demand_modal_list">
          <img v-if="serviceInfo.orderFiles.length == 0 && serviceInfo.orderCases.length == 0" :src="require('@/assets/img/shopping_cart_empty.png')"/>
          <p style="text-align: center" v-if="serviceInfo.orderFiles.length == 0 && serviceInfo.orderCases.length == 0">该服务商还没有关联任何案例或附件～</p>

          <div class="my_project_demand_modal_list_title" v-show="serviceInfo.orderFiles.length > 0">
            相关附件：
          </div>
          <el-table :data="serviceInfo.orderFiles" border style="width: 100%" class="my_project_demand_modal_table"  v-show="serviceInfo.orderFiles.length > 0">
            <el-table-column prop="filename" label="附件名称" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_service">
                  <el-button type="text" @click="seeOrderFile(scope.row)">{{scope.row.filename}}</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="annex_desc" label="附件说明" align="center"> </el-table-column>
            <el-table-column prop="datetime" label="上传时间" align="center"> </el-table-column>
          </el-table>
          <div class="my_project_demand_modal_list_title" v-show="serviceInfo.orderCases.length > 0">
            关联案例：
          </div>
          <div class="my_project_demand_modal_list_wrap" v-show="serviceInfo.orderCases.length > 0">
            <!-- :class="index === 0 && 'my_project_demand_modal_list_item_select'" -->
            <div v-for="(item,index) in serviceInfo.orderCases" class="my_project_demand_modal_list_item" title="点击查看案例详情" :key="index" @click="seeCaseDetail(item)">
              <img :src="item.case_cover" />
              <div class="my_project_demand_modal_list_item_info">
                <div class="my_project_demand_modal_list_item_info_name">
                  <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                    <span style="overflow: hidden; max-width: 180px; height: 22px; white-space: nowrap; text-overflow: ellipsis;">{{ item.name }}</span>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="item.category_top_name" placement="bottom">
                    <span class="my_project_demand_modal_list_item_info_tag" style="overflow: hidden; max-width: 80px; height: 22px; white-space: nowrap; text-overflow: ellipsis;">{{ item.category_top_name }}</span>
                  </el-tooltip>
                </div>
                <div class="my_project_demand_modal_list_item_info_type">
                  {{ item.category_second_name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

    </div>
  </div>

</template>

<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
import * as commfun from '@/common/common.js'
var pubPrefix = '/api'
export default {
  name: 'OrderDetail',
  components: {
    Mainl
  },
  computed: {
    formatRequirement() {
      var selfthis=this
      return selfthis.orderInfo.requirement.replace(/\n/g, '<br>');
    }
  },
  data: function () {
    return {
      statusMapDesc: {
        1: '待分配',
        2: '待确认',
        3: '进行中',
        4: '已完成',
        5: '已取消'
      },
      orderId: 0,
      orderInfo: {},
      companyInfo: {},
      serviceInfo: {
        serviceCompany: '', // 服务商公司名
        serviceUserId: '',
        orderId: '',
        orderFiles: [],  // 关联附件
        orderCases: []   // 关联案例
      },
      serviceInfoVisible: false,
      originalityInfo: [],
      annexData: [],  // 订单附件
      // 新的订单状态：1：待派单，2：待接单【服务方显示为待报名】，3：待选择【服务方显示为候选中】，4：待执行，5：执行中，6：待验收，7：已完成，8：已取消
      scale: 0,
      timeLine:[],
      cancelTimeLine: {
        label:'已取消',
        orderStatus: 8,
        icon: require('@/assets/img/icon_time_line_2.png'),
        activeIcon: require('@/assets/img/icon_time_line_2_cancel.png'),
        desc:''
      },
      // 待接单 包含代派单1和待接单2两种状态
      waitingOrderTimeLine: {
        label:'待接单',
        // orderStatus: [1, 2],
        icon: require('@/assets/img/icon_time_line_1.png'),
        activeIcon: require('@/assets/img/icon_time_line_1.png'),
      },
      allTimeLine:[
        {
          label:'待选择',
          orderStatus: 3,
          icon: require('@/assets/img/icon_time_line_2.png'),
          activeIcon: require('@/assets/img/icon_time_line_2_active.png'),
        },
        {
          label:'待执行',
          orderStatus: 4,
          icon: require('@/assets/img/icon_time_line_2.png'),
          activeIcon: require('@/assets/img/icon_time_line_2_active.png'),
        },
        {
          label:'执行中',
          orderStatus: 5,
          icon: require('@/assets/img/icon_time_line_2.png'),
          activeIcon: require('@/assets/img/icon_time_line_2_active.png'),
        },
        {
          label:'待验收',
          orderStatus: 6,
          icon: require('@/assets/img/icon_time_line_2.png'),
          activeIcon: require('@/assets/img/icon_time_line_2_active.png'),
        },
        {
          label:'已完成',
          orderStatus: 7,
          icon: require('@/assets/img/icon_time_line_finish.png'),
          activeIcon: require('@/assets/img/icon_time_line_finish_active.png'),
        },
      ],
    }
  },
  mounted () {
    var queryString = window.location.search
    var urlParams = new URLSearchParams(queryString)
    var orderId = urlParams.get('order_id')
    this.orderId = orderId
    // 获取详情数据
    this.initData()
  },
  methods: {
    // 获取数据
    initData: function () {
      var selfthis = this
      var url = pubPrefix + '/api/order/demandOrderDetail'
      var postdata = {order_id: this.orderId}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.orderInfo = data
        selfthis.cancelTimeLine.desc = selfthis.orderInfo.cancel_reason
        if (data.company_arr != null && data.company_arr !== undefined) {
          selfthis.companyInfo = data.company_arr
        }
        if (data.goods_info != null && data.goods_info !== undefined && data.goods_info.length > 0) {
          selfthis.originalityInfo = data.goods_info
        }
        if (data.annex_data != null && data.annex_data !== undefined && data.annex_data.length > 0) {
          selfthis.annexData = data.annex_data
        }
        selfthis.setProgressBar()
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 设置进度条
    setProgressBar () {
      var cancelOrderStatus = this.orderInfo.cancel_order_status
      var timeLineArr = []
      if (cancelOrderStatus != 0) {  // 在流程中的某个状态取消了
        for (var i in this.allTimeLine) {
          if (this.allTimeLine[i].orderStatus <= cancelOrderStatus) {
            timeLineArr.push(this.allTimeLine[i])
          }
        }
        if (this.orderInfo.order_status == 8) {
          timeLineArr.push(this.cancelTimeLine)
        }
      } else { // 没取消则显示全部流程
        timeLineArr = this.allTimeLine
      }
      timeLineArr.unshift(this.waitingOrderTimeLine)
      var allOrderStatusArr = []
      for (var k in timeLineArr) {
        if (timeLineArr[k].orderStatus != undefined) {
          allOrderStatusArr.push(timeLineArr[k].orderStatus)
        }
      }
      var limeLineLength = allOrderStatusArr.length
      var nowScale = 0
      for (var j in timeLineArr) {
        var divisor = 0  // 除数  scale = divisor / limeLineLength  进度条显示百分比 = 当前状态所在进度 / 状态总长度
        var scale = 0;
        if (timeLineArr[j].orderStatus == undefined) {
          timeLineArr[j].value = 0
        } else {
          var index = allOrderStatusArr.indexOf(timeLineArr[j].orderStatus);
          divisor = index + 1
          if (limeLineLength > 0) {
            scale = (divisor / limeLineLength).toFixed(2) * 100
          }
          timeLineArr[j].value = scale
          if (timeLineArr[j].orderStatus == this.orderInfo.order_status) {
            nowScale = scale
          }
        }
      }
      this.scale = nowScale
      this.timeLine = timeLineArr
    },
    handleClose2(done) {
      this.serviceInfoVisible = false
    },
    // 查看服务商信息
    showServiceInfo (service_userid) {
      var selfthis = this
      selfthis.serviceInfo.serviceUserId = service_userid
      selfthis.serviceInfo.orderId = this.orderId
      selfthis.serviceInfoVisible = true
      // 查询服务方案例和附件
      var url = pubPrefix + '/api/order_material/getOrderMaterial'
      var postdata = {service_userid: service_userid, order_id: this.orderId}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.serviceInfo.orderFiles = data.annexData
        selfthis.serviceInfo.orderCases = data.caseData
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    isEmpty(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    },
    // 查看文件
    seeOrderFile (item) {
      window.open(item.url)
    },
    // 案例详情
    seeCaseDetail (item) {
      window.open('/casedetail?id=' + item.case_id + '&jump_from=1')
    },
    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrderDetail.vue